import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import { useCallback, useRef } from 'react';
import uniq from 'lodash/uniq';
import { di } from 'react-magnetic-di';
import { useRelayEnvironment } from 'react-relay';
import { useAnalyticsEvents } from '@atlaskit/analytics-next';
import { LOOKUP_SOURCE_USERS_ASYNC_DATA } from '../../../common/constants';
import { isNotAutomaticId } from '../../../common/utils/is-not-automatic-id';
import { fetchUsers } from '../../../services/fetch-users';
import { useFormMetadata } from '../../issue-adjustments/hooks/use-form-metadata';
import { useViewType } from '../../issue-adjustments/hooks/use-view-type';
import { getSupportedFieldConfiguration } from '../../view-configuration';
export var useLookupFieldData = function useLookupFieldData() {
  var _useAnalyticsEvents = useAnalyticsEvents(),
    createAnalyticsEvent = _useAnalyticsEvents.createAnalyticsEvent;
  var environment = useRelayEnvironment();
  var formMetadata = useFormMetadata();
  var formMetadataRef = useRef(formMetadata);
  var viewType = useViewType();

  /**
   * We want to have an up-to-date data when this hook's
   * returned function is being called in useSubmit callback function
   * thats why we keep it in a ref object
   */
  formMetadataRef.current = formMetadata;
  return useCallback( /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(fieldsChanges) {
      var lookupData, asyncFieldsValues, users, uniqueAccountIds;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            lookupData = {};
            asyncFieldsValues = Object.entries(fieldsChanges).reduce(function (acc, _ref2) {
              var _ref3 = _slicedToArray(_ref2, 2),
                fieldId = _ref3[0],
                fieldData = _ref3[1];
              if (!formMetadataRef.current[fieldId]) {
                return acc;
              }
              var fieldType = formMetadataRef.current[fieldId].fieldType;
              var fieldValue = fieldData.value;
              var supportedFieldsConfiguration = getSupportedFieldConfiguration(viewType, fieldType);
              var lookupSource = supportedFieldsConfiguration === null || supportedFieldsConfiguration === void 0 ? void 0 : supportedFieldsConfiguration.lookupSource;
              var isUserLookupField = lookupSource === LOOKUP_SOURCE_USERS_ASYNC_DATA;
              if (isUserLookupField && fieldValue && isNotAutomaticId(fieldValue)) {
                var currentAccountIds = acc.accountIds ? _toConsumableArray(acc.accountIds) : [];
                var newAccountIds = Array.isArray(fieldValue) ? fieldValue : [fieldValue];
                acc.accountIds = [].concat(_toConsumableArray(currentAccountIds), _toConsumableArray(newAccountIds));
              }
              /** Add extra checks to add other lookup type e.g. issues lookup */

              return acc;
            }, {});
            users = [];
            if (!asyncFieldsValues.accountIds) {
              _context.next = 8;
              break;
            }
            uniqueAccountIds = uniq(asyncFieldsValues.accountIds);
            _context.next = 7;
            return fetchUsers(environment, uniqueAccountIds, createAnalyticsEvent);
          case 7:
            users = _context.sent;
          case 8:
            lookupData[LOOKUP_SOURCE_USERS_ASYNC_DATA] = users;
            return _context.abrupt("return", lookupData);
          case 10:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return function (_x) {
      return _ref.apply(this, arguments);
    };
  }(), [createAnalyticsEvent, viewType, environment]);
};